/* Auth helpers. */

export const getBearerToken = () => {
  return localStorage.getItem('reggora_lender_auth_token')
}
